import type {MeticulousPublicApi} from '@alwaysmeticulous/sdk-bundles-api';
import {isFirefox, isSafari} from '@wandb/weave/common/util/browser';
import {type useHistory} from 'react-router-dom';

import {urlPrefixed} from '../config';
import {type GlobalViewer} from './datadog/constants';
import {stripOriginFromURL} from './urls';

// Expect these items to be in the window object.
declare global {
  interface Window {
    ga: any;
    Beamer: any;
    __REDUX_DEVTOOLS_EXTENSION__?: any;
    __PREVIOUSLY_LOGGED_IN?: boolean;
    __WB_authRedirect?: string;
    __INITIALIZE_PENDO?: () => void;
    __WB_WYSIWYG_CONVERSION_REVERT?: () => void;
    __WB_workspaceLoadingVitals?: Record<string, number>;
    METICULOUS_MAX_PAYLOAD_SIZE?: number;
    // https://app.meticulous.ai/docs/how-to/typescript-types
    Meticulous?: MeticulousPublicApi;
    store: any; // To allow Cypress to access redux store - configured in setup.ts
  }
}

export function openInNewTab(
  url: string,
  history: ReturnType<typeof useHistory>
): void {
  // HAX: Firefox & Safari blocks new tabs by default, treating it as a popup window
  if (isFirefox || isSafari) {
    history.push(stripOriginFromURL(url));
    return;
  }
  window.open(urlPrefixed(url), undefined, 'noopener,noreferrer');
}

// Don't flag as IFrame if we're mounted in a service like Kubeflow.
// Do flag as IFrame if we're rendered in Kubeflow notebooks.
export function isInIframe() {
  try {
    return (
      window.self !== window.top &&
      (window.self.location.origin !== window.top?.location.origin ||
        window.top.location.pathname.startsWith('/notebook'))
    );
  } catch (e) {
    return true;
  }
}
